"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-options" };
const _hoisted_2 = {
    key: 0,
    class: "wf-title"
};
const _hoisted_3 = {
    key: 1,
    class: "wf-action"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_player_input_factory = (0, vue_1.resolveComponent)("player-input-factory");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)((_ctx.playerinput.options || []), (option, idx) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_player_input_factory, {
                key: idx,
                ref_for: true,
                ref: "childInputs",
                players: _ctx.players,
                playerView: _ctx.playerView,
                playerinput: option,
                onsave: _ctx.playerFactorySaved(idx),
                showsave: false,
                showtitle: true
            }, null, 8, ["players", "playerView", "playerinput", "onsave"]));
        }), 128)),
        (_ctx.showsave)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    title: _ctx.playerinput.buttonLabel,
                    type: "submit",
                    size: "normal",
                    onClick: _ctx.saveData,
                    disabled: !_ctx.canSave()
                }, null, 8, ["title", "onClick", "disabled"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
